export const { URL, URLSearchParams } = window;
